import { action, makeObservable } from "mobx";
import axios from "axios";
import { serverUrl } from ".";

export class RootStore {
  constructor() {
    makeObservable(this, {
      trackPageView: action,
    });
  }
  trackPageView = async (params: { sessionId: string; pagePath: string; trafficSource: string; sourceLink: string; }) => {
    try {
      await axios.post(`${serverUrl}/metrics`, params);
    } catch (err) {
      console.error("quotesStore.ts => getFormFields:", err);
    }
  };
}

const rootStore = new RootStore();

export default rootStore;
